import { render, staticRenderFns } from "./blockChain.vue?vue&type=template&id=7ca922c9&"
import script from "./blockChain.vue?vue&type=script&lang=js&"
export * from "./blockChain.vue?vue&type=script&lang=js&"
import style0 from "./blockChain.vue?vue&type=style&index=0&id=7ca922c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports